import http from './http'

import qs from 'qs'

function formatQueryString (params) {
  Object.keys(params).forEach(el => {
    if (!params[el]) {
      params[el] = undefined
    }
  })
  return qs.stringify(params, {
    arrayFormat: 'brackets',
    addQueryPrefix: true,
    encode: false
  })
}

export default {
  teachers: {
    list ({
      name,
      status,
      email,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get('/teachers' + formatQueryString({
        name,
        status,
        email,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    create ({
      provider,
      email,
      password,
      password_confirmation,
      first_name,
      last_name,
      cellphone,
      skype
    }) {
      return http.post('/teachers', {
        provider,
        email,
        password,
        password_confirmation,
        first_name,
        last_name,
        cellphone,
        skype
      })
    }
  },
  students: {
    list ({
      name,
      status,
      account_type,
      email,
      teacher_id,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get('/students' + formatQueryString({
        name,
        status,
        account_type,
        email,
        teacher_id,
        page,
        per_page,
        order_by,
        fields
      }))
    }
  },
  users: {
    profile () {
      return http.get('/users/profile')
    },
    list ({
      name,
      status,
      email,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get('/users' + formatQueryString({
        name,
        status,
        email,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    create ({
      provider,
      email,
      password,
      password_confirmation,
      first_name,
      last_name,
      cellphone,
      skype
    }) {
      return http.post('/users', {
        provider,
        email,
        password,
        password_confirmation,
        first_name,
        last_name,
        cellphone,
        skype
      })
    },
    save (id, {
      email,
      first_name,
      last_name,
      cellphone,
      skype
    }) {
      return http.put('/users/' + id, {
        by: 'profile',
        email,
        first_name,
        last_name,
        cellphone,
        skype
      })
    },
    savePassword (id, {
      password,
      password_confirmation
    }) {
      return http.put('/users/' + id, {
        by: 'admin',
        password,
        password_confirmation
      })
    },
    delete (id) {
      return http.delete('/users/' + id)
    },
    disable (id) {
      return http.put(`/users/${id}/disable`)
    },
    enable (id) {
      return http.put(`/users/${id}/enable`)
    },
    set_admin (id) {
      return http.put(`/users/${id}/set_admin`)
    },
    login ({
      provider,
      email,
      password
    }) {
      return http.post('/users/login', {
        provider,
        email,
        password,
        client: 'web'
      })
    },
    password_reset_request (email) {
      return http.post('/users/password_reset_request', {
        email
      })
    },
    password ({
      reset_password_token,
      password,
      password_confirmation
    }) {
      return http.put('/users/password', {
        reset_password_token,
        password,
        password_confirmation
      })
    }
  },

  courses: {
    list ({
      name,
      teacher_id,
      student_id,
      status,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get('/courses' + formatQueryString({
        name,
        teacher_id,
        student_id,
        status,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    create ({
      name,
      teacher_id,
      student_members_attributes,
      lessons_attributes
    }) {
      return http.post('/courses', {
        name,
        teacher_id,
        student_members_attributes,
        lessons_attributes
      })
    },
    save (id, {
      name,
      teacher_id,
      hours,
      lessons_count
    }) {
      return http.put('/courses/' + id, {
        name,
        teacher_id,
        hours,
        lessons_count
      })
    },
    delete (id) {
      return http.delete('/courses/' + id)
    },
    start (id) {
      return http.put(`/courses/${id}/start`)
    },
    finish (id) {
      return http.put(`/courses/${id}/finish`)
    },
    teachers (id) {
      return http.get(`/courses/${id}/teachers`)
    },
    add_teacher (id, user_id) {
      return http.post(`/courses/${id}/teachers`, { user_id })
    },
    delete_teacher (id, tid) {
      return http.delete(`/courses/${id}/teachers/${tid}`)
    },
    students ({
      id,
      name,
      status,
      email,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get(`/courses/${id}/students` + formatQueryString({
        name,
        status,
        email,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    add_student (id, user_id) {
      return http.post(`/courses/${id}/students`, { user_id })
    },
    delete_student (id, tid) {
      return http.delete(`/courses/${id}/students/${tid}`)
    },
    lessons ({ id, subject, lesson_date }) {
      return http.get(`/courses/${id}/lessons` + formatQueryString({ subject, lesson_date }))
    },
    create_lesson (id, {
      subject,
      hours,
      datetime,
      content,
      note
    }) {
      return http.post(`/courses/${id}/lessons`, {
        subject,
        hours,
        datetime,
        content,
        note
      })
    }
  },
  lessons: {
    list ({ subject, lesson_date }) {
      return http.get(`/lessons` + formatQueryString({ subject, lesson_date }))
    },
    save (id, {
      subject,
      hours,
      datetime,
      content,
      note
    }) {
      return http.put(`/lessons/${id}`, {
        subject,
        hours,
        datetime,
        content,
        note
      })
    },
    delete (id) {
      return http.delete(`/lessons/${id}`)
    }
  },
  topic_types: {
    list () {
      return http.get(`/topic_types`)
    }
  },
  topics: {
    my ({
      page,
      per_page,
      order_by
    }) {
      return http.get(`/topics/my`, {
        page,
        per_page,
        order_by
      })
    },
    list ({
      page,
      per_page,
      order_by
    }) {
      return http.get(`/topics`, {
        page,
        per_page,
        order_by
      })
    },
    create ({
      topic_type_id,
      transcripts_attributes,
      show_subtitle,
      video_id,
      article_references_attributes
    }) {
      return http.post(`/topics`, {
        topic_type_id,
        transcripts_attributes,
        show_subtitle,
        video_id,
        article_references_attributes
      })
    },
    save (id, {
      topic_type_id,
      transcripts_attributes,
      show_subtitle,
      video_id,
      article_references_attributes
    }) {
      return http.put(`/topics/${id}`, {
        topic_type_id,
        transcripts_attributes,
        show_subtitle,
        video_id,
        article_references_attributes
      })
    },
    delete (id) {
      return http.delete(`/topics/${id}`)
    },
    copy (id) {
      return http.put(`/topics/${id}/copy`)
    },
    score (id, homework_id) {
      return http.post(`/topics/${id}/score`, { homework_id })
    },
    ownership (id, teacher_id) {
      return http.put(`/topics/${id}/ownership`, { teacher_id })
    },
    privacy (id, permission) {
      return http.put(`/topics/${id}/privacy`, { permission })
    }
  },
  tasks: {
    list ({
      name,
      course_id,
      lesson_id,
      teacher_name,
      datetime,
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get('/tasks' + formatQueryString({
        name,
        course_id,
        lesson_id,
        teacher_name,
        datetime,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    create ({
      lesson_id,
      name
    }) {
      return http.post('/tasks', {
        lesson_id,
        name
      })
    },
    save (id, {
      lesson_id,
      name
    }) {
      return http.put('/tasks/' + id, {
        lesson_id,
        name
      })
    },
    delete (id) {
      return http.delete('/tasks/' + id)
    },
    topics (id) {
      return http.get(`/tasks/${id}/topics`)
    },
    topics_create (id, topic_id) {
      return http.post(`/tasks/${id}/topics`, { topic_id })
    },
    topics_delete (id, tid) {
      return http.delete(`/tasks/${id}/topics/${tid}`)
    },
    start (id, student_ids) {
      return http.put(`/tasks/${id}/start`, { student_ids })
    },
    finish (id) {
      return http.put(`/tasks/${id}/finish`)
    },
    push_homework (id, idArray) {
      return http.put(`/tasks/${id}/students`, idArray)
    },
    cancel_homework (id, idArray) {
      return http.delete(`/tasks/${id}/students`, idArray)
    },
    homeworks (id) {
      return http.get(`/tasks/${id}/homeworks`)
    },
    homework_submit (id, {
      total_score,
      scores
    }) {
      return http.get(`/tasks/${id}/homework/submit` + formatQueryString({
        total_score,
        scores
      }))
    },
    reminders (id, {
      receivers,
      content
    }) {
      return http.get(`/tasks/${id}/homework/reminders` + formatQueryString({
        receivers,
        content
      }))
    }
  },
  homework: {
    reply (id, { content, reply_id }) {
      return http.post(`/homework/${id}/reply`, { content, reply_id })
    }
  },
  homeworks: {
    list ({
      course_id,
      teacher_name,
      student_name,
      class_date_gteq,
      class_date_lt,
      status, // waiting, submitted, finished
      page,
      per_page,
      order_by,
      fields
    }) {
      return http.get(`/homeworks` + formatQueryString({
        course_id,
        teacher_name,
        student_name,
        class_date_gteq,
        class_date_lt,
        status,
        page,
        per_page,
        order_by,
        fields
      }))
    },
    detail (id) {
      return http.get(`/homeworks/${id}`)
    }
  }
}
